import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, TrendingUp, Users } from 'lucide-react';
import { SalesButton } from '../ui/SalesButton';
export function Hero() {
  const benefits = ['Visibly reduce face and body puffiness within 7 days', 'Support natural drainage and feel lighter within 2 weeks', 'Boost daily energy and mental clarity within 10 days', 'Promote smoother, more radiant skin within 3 weeks', 'Maintain lasting balance and vitality with daily use'];
  const quickBundles = [{
    bottles: 1,
    price: 39.99,
    originalPrice: 59.99,
    label: 'Try It',
    savings: '33% OFF'
  }, {
    bottles: 3,
    price: 79.98,
    originalPrice: 179.97,
    label: 'Most Popular',
    savings: '56% OFF',
    badge: 'BEST VALUE',
    isPopular: true
  }, {
    bottles: 5,
    price: 119.97,
    originalPrice: 299.95,
    label: 'Ultimate',
    savings: '60% OFF'
  }];
  return <section className="relative bg-gradient-to-br from-[#F0FFF4] to-white pt-12 pb-20 overflow-hidden" data-id="element-96">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#10B981]/5 rounded-l-[100px] -z-10" data-id="element-97" />

      {/* Urgency banner */}
      <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-20" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-red-500 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg flex items-center space-x-2" data-id="element-99">
          <TrendingUp className="w-4 h-4" data-id="element-100" />
          <span data-id="element-101">🔥 847 bottles sold in the last 24 hours</span>
        </motion.div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12" data-id="element-102">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-103">
          {/* Left Column: Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-8" data-id="element-104">
            <div className="flex items-center space-x-2 text-[#10B981] font-medium tracking-wide uppercase text-sm" data-id="element-105">
              <span className="px-3 py-1 bg-[#10B981]/10 rounded-full animate-pulse" data-id="element-106">
                ⚡ Limited Stock
              </span>
              <span data-id="element-107">Free US Shipping</span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#1B5E20] leading-tight" data-id="element-108">
              Feel Lighter, <br data-id="element-109" />
              <span className="text-[#10B981]" data-id="element-110">Look Slimmer,</span> <br data-id="element-111" />
              Glow From Within
            </h1>

            <p className="text-xl text-[#374151] leading-relaxed max-w-xl font-medium" data-id="element-112">
              LymphoriaX is a gentle liquid herbal formula that supports healthy
              lymphatic flow to reduce puffiness, release trapped fluid, and
              restore your natural energy.
            </p>

            <div className="space-y-4" data-id="element-113">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.2 + index * 0.1
            }} className="flex items-start space-x-3" data-id="element-114">
                  <div className="mt-1 bg-[#10B981] p-1 rounded-full" data-id="element-115">
                    <Check className="w-4 h-4 text-white" data-id="element-116" />
                  </div>
                  <span className="text-[#374151] font-medium" data-id="element-117">{benefit}</span>
                </motion.div>)}
            </div>

            <div className="pt-4 space-y-4" data-id="element-118">
              <div className="flex flex-col sm:flex-row gap-4 items-center sm:items-start" data-id="element-119">
                <SalesButton onClick={() => document.getElementById('pricing')?.scrollIntoView({
                behavior: 'smooth'
              })} data-id="element-120">
                  Get LymphoriaX Now
                </SalesButton>
                <div className="flex flex-col items-center sm:items-start" data-id="element-121">
                  <div className="flex text-[#10B981]" data-id="element-122">
                    {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-current" data-id="element-123" />)}
                  </div>
                  <span className="text-sm text-[#374151] mt-1 font-bold" data-id="element-124">
                    4.9/5 from 12,847+ women
                  </span>
                </div>
              </div>

              {/* Quick Bundle Preview */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.8
            }} className="bg-white rounded-2xl p-6 shadow-xl border-2 border-[#10B981]/20" data-id="element-125">
                <div className="flex items-center justify-between mb-4" data-id="element-126">
                  <h3 className="font-bold text-[#1B5E20] text-lg" data-id="element-127">
                    Choose Your Bundle:
                  </h3>
                  <span className="text-xs text-[#10B981] font-bold bg-[#10B981]/10 px-3 py-1 rounded-full" data-id="element-128">
                    SAVE UP TO 60%
                  </span>
                </div>

                <div className="grid grid-cols-3 gap-3" data-id="element-129">
                  {quickBundles.map((bundle, i) => <motion.button key={i} whileHover={{
                  scale: 1.05
                }} whileTap={{
                  scale: 0.95
                }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
                  behavior: 'smooth'
                })} className={`
                        relative p-4 rounded-xl border-2 transition-all cursor-pointer
                        ${bundle.isPopular ? 'border-[#10B981] bg-[#10B981]/5 shadow-lg' : 'border-gray-200 hover:border-[#10B981]/50'}
                      `} data-id="element-130">
                      {bundle.badge && <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-2 py-0.5 rounded-full text-[10px] font-bold whitespace-nowrap" data-id="element-131">
                          {bundle.badge}
                        </div>}

                      {/* Product bottles visualization */}
                      <div className="flex justify-center items-end mb-2 h-16" data-id="element-132">
                        {[...Array(bundle.bottles)].map((_, idx) => <motion.img key={idx} initial={{
                      opacity: 0,
                      y: 10
                    }} animate={{
                      opacity: 1,
                      y: 0
                    }} transition={{
                      delay: 0.9 + idx * 0.1
                    }} src="https://cdn.magicpatterns.com/uploads/fmti55VufUKBbuVqKcuFFP/LymphoriaX.png" alt="LymphoriaX Bottle" className={`
                              drop-shadow-md
                              ${bundle.bottles === 1 ? 'w-12' : ''}
                              ${bundle.bottles === 3 ? 'w-10 -ml-2 first:ml-0' : ''}
                              ${bundle.bottles === 5 ? 'w-8 -ml-2 first:ml-0' : ''}
                            `} data-id="element-133" />)}
                      </div>

                      <div className="text-center" data-id="element-134">
                        <div className="text-xs text-[#374151] font-medium mb-1" data-id="element-135">
                          {bundle.label}
                        </div>
                        <div className="text-lg font-bold text-[#1B5E20]" data-id="element-136">
                          ${bundle.price}
                        </div>
                        <div className="text-[10px] line-through text-gray-400" data-id="element-137">
                          ${bundle.originalPrice}
                        </div>
                        <div className="text-[10px] font-bold text-red-500 mt-1" data-id="element-138">
                          {bundle.savings}
                        </div>
                      </div>
                    </motion.button>)}
                </div>

                <div className="mt-4 text-center text-xs text-[#374151]" data-id="element-139">
                  <span className="font-medium" data-id="element-140">✓ Free Shipping</span>
                  <span className="mx-2" data-id="element-141">•</span>
                  <span className="font-medium" data-id="element-142">✓ 60-Day Guarantee</span>
                </div>
              </motion.div>

              {/* Social proof */}
              <div className="flex items-center space-x-2 text-sm text-[#374151] bg-white/80 backdrop-blur-sm px-4 py-3 rounded-xl border border-[#10B981]/20" data-id="element-143">
                <Users className="w-5 h-5 text-[#10B981]" data-id="element-144" />
                <span data-id="element-145">
                  <strong className="text-[#10B981]" data-id="element-146">2,847 women</strong> are
                  viewing this right now
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-147">
            <div className="relative aspect-square rounded-3xl overflow-hidden shadow-2xl bg-gradient-to-br from-white to-[#F0FFF4] p-8" data-id="element-148">
              {/* Real product image */}
              <img src="https://cdn.magicpatterns.com/uploads/fmti55VufUKBbuVqKcuFFP/LymphoriaX.png" alt="LymphoriaX Bottle" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-149" />

              {/* Floating Badge */}
              <motion.div animate={{
              y: [0, -10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 4,
              ease: 'easeInOut'
            }} className="absolute top-8 right-8 bg-white/95 backdrop-blur-sm p-4 rounded-2xl shadow-xl max-w-[160px] border-2 border-[#10B981]/20" data-id="element-150">
                <div className="text-[#10B981] font-bold text-lg mb-1" data-id="element-151">
                  100% Natural
                </div>
                <div className="text-xs text-[#374151]" data-id="element-152">
                  Plant-based herbal formula
                </div>
              </motion.div>

              {/* Bottom Badge */}
              <div className="absolute bottom-8 left-8 bg-[#1B5E20] text-white p-4 rounded-xl shadow-xl" data-id="element-153">
                <div className="font-bold text-xl" data-id="element-154">60-Day</div>
                <div className="text-sm opacity-90" data-id="element-155">Money Back Guarantee</div>
              </div>

              {/* Stock indicator */}
              <div className="absolute top-8 left-8 bg-red-500 text-white px-3 py-2 rounded-lg text-xs font-bold shadow-lg animate-pulse" data-id="element-156">
                Only 47 left!
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}